import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../ContextApi/ContextApi';
import './Profile.css';
import { API_URL } from '../../api/apiurls';
import Navbar from '../../shared/Navbar';

const ProfilePage = () => {
  const { logoutUser, user, userName } = useContext(AuthContext);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetch(`${API_URL}user-detail/${userName}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch user details');
        }

        const data = await response.json();
        if (data.length > 0) {
          setUserDetails(data[0]);
        } else {
          throw new Error('User not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [userName]);  // Only depend on userName

  if (loading) {
    return (
      <div className="profile-container">
        <div className="loading-spinner"></div>
        <p>Loading profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="profile-container">
        <div className="error-message">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!userDetails) {
    return (
      <div className="profile-container">
        <p>User not found</p>
      </div>
    );
  }

  return (
    <div> 
        <Navbar/>  
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">
          {userDetails.first_name?.charAt(0)}{userDetails.last_name?.charAt(0)}
        </div>
        <h2>{userDetails.first_name} {userDetails.last_name}</h2>
        <p className="username">@{userDetails.username}</p>
      </div>

      <div className="profile-details">
        <div className="detail-item">
          <span className="detail-label">Email:</span>
          <span className="detail-value">{userDetails.email}</span>
        </div>
        
        <div className="detail-item">
          <span className="detail-label">Mobile:</span>
          <span className="detail-value">{userDetails.mobile}</span>
        </div>
        
        <div className="detail-item">
          <span className="detail-label">Joined Date:</span>
          <span className="detail-value">{userDetails.date_joined}</span>
        </div>
        
        <div className="detail-item">
          <span className="detail-label">Bank:</span>
          <span className="detail-value">{userDetails.bank}</span>
        </div>
        
        <div className="detail-item">
          <span className="detail-label">Agent Code:</span>
          <span className="detail-value">{userDetails.agentPrinterCode}</span>
        </div>
      </div>

      <div className="profile-actions">
        {/* <button className="edit-button">Edit Profile</button> */}
        {/* <button className="logout-button" onClick={logoutUser}>
          Logout
        </button> */}
      </div>
    </div>
    </div>
  );
};

export default ProfilePage;